import classNames from 'classnames';
import React, { useMemo } from 'react';
import { IChatTextMessage, IMessageQuickRepliesMeta } from '@enuan/chat__utils';
import {
	QuickRepliesWrapper,
	type IQuickRepliesWrapperProps,
} from '../../message/content';
import { Text } from '../../message/content';
import { useMessageContext } from '../../message/message.context';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../../UI/Message/Message';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type IQuickRepliesMessageContent = IChatTextMessage<
	IMessageQuickRepliesMeta & { keep?: boolean }
>;

export const QuickRepliesMessage = React.forwardRef<
	HTMLElement,
	{
		onQuickReplies?: IQuickRepliesWrapperProps['onClick'];
		className?: string;
	} & IOptionalMessageProps
>(function QuickRepliesMessage({ className, onQuickReplies, ...props }, ref) {
	const { message, isLastBlock, isLastMessage } =
		useMessageContext<IQuickRepliesMessageContent>();
	const { metadata: { keep } = {} } = message;
	const messageClassName = useBlockMessageClassNames();
	const showQuickReplies =
		(isLastBlock && isLastMessage) || keep || !!onQuickReplies;
	const customExtra = useMemo(
		() =>
			showQuickReplies ? (
				<QuickRepliesWrapper onClick={onQuickReplies} />
			) : undefined,
		[showQuickReplies, onQuickReplies],
	);

	return (
		<Message
			{...props}
			ref={ref}
			message={message}
			className={classNames(
				className,
				messageClassName,
				'message--quick-replies',
			)}
			customExtra={customExtra}
		>
			<Text />
		</Message>
	);
});
